import { ApiResponse, PaginatedResponse } from '../../../types';
import { api } from '../../../app/store/api';
 
export const invoiceApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getInvoicesList: builder.query<
            PaginatedResponse<unknown>,
            { page?: number; perPage?: number; search?: object }
        >({
            query: ({ page, perPage = 15, search }) => ({
                url: `workspace/invoices`,
                method: 'GET',
                params: {
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                    ...(search && {
                        search: JSON.stringify({ ...search }),
                    }),
                },
            }),
            providesTags: ['Invoice'],
        }),

        storeInvoice: builder.mutation<{ data: any; status: string }, any>({
            query: (data) => ({
                url: 'workspace/invoices',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Invoice' }] : []),
        }),

        updateInvoice: builder.mutation<
            { data: any; status: string },
            { id: number; data: any }
        >({
            query: (body) => ({
                url: `workspace/invoices`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Invoice' }] : []),
        }),

        removeInvoice: builder.mutation<ApiResponse<unknown>, number>({
            query: (id) => ({
                url: `workspace/invoices`,
                method: 'DELETE',
                body: { id },
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Invoice' }] : []),
        }),
    }),
});

export const {
    useGetInvoicesListQuery,
    useStoreInvoiceMutation,
    useUpdateInvoiceMutation,
    useRemoveInvoiceMutation,
} = invoiceApi;
